import { render } from "./pc_user_description.vue?vue&type=template&id=13a9c37f&scoped=true"
import script from "./pc_user_description.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_user_description.vue?vue&type=script&scoped=true&lang=js"

import "./pc_user_description.vue?vue&type=style&index=0&id=13a9c37f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a9c37f"]])

export default __exports__